import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconComponent } from '../../../icon/icon.component';
import { LoadingSpinnerComponent } from '../../../loading/loading-spinner/loading-spinner.component';
import { BaseProgressComponent } from '../base-progress.component';

@Component({
  selector: 'nrc-pdf-export-progress',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './pdf-export-progress.component.html',
  styleUrl: './pdf-export-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfExportProgressComponent extends BaseProgressComponent {}
